export default __webpack_public_path__ + "static/media/my-resources-active.569c9e50.svg";